<h3 class="ui header light user-step-title">Student Assessment methods</h3>

<div *ngIf="loading.isLoading;else loaded">
  <app-loading [loadingText]="loading.text"></app-loading>
</div>

<ng-template #loaded>

  <app-load-error *ngIf="loadError; else noErrors" [loadError]="loadError">
  </app-load-error>


  <ng-template #noErrors>

    <!-- <app-action-errors *ngIf="actionErrors.length > 0" [title]="actionErrorTitle" [actionErrors]="actionErrors">
    </app-action-errors> -->


    <div class="user-step-instruction">
      List the student assessment methods used in this course. If you use an assessment method more than once, list it
      for each
      time used (e.g. list quiz three times if used three times).
    </div>

    <div class="content">


      <div *ngIf="!assessmentFormat.isEnabled" class="ui message">
        You are not required to enter assessment methods for this curriculum review.
      </div>

      <div *ngIf="assessmentFormat.isEnabled && selectedAssessmentMethods.length == 0" class="ui message">
        You have not listed any assessment methods for this course.
      </div>


      <table *ngIf="assessmentFormat.isEnabled && selectedAssessmentMethods.length != 0" class="ui table assessment-table">

        <tr class='header-row'>
          <td>Student Assessment method</td>
          <td *ngIf="assessmentFormat.isWeightRequired" class="weight-col">Weight (%)


            <!-- <div class="tooltip"> -->
            <span class="tooltip-wrapper" data-tooltip="Percentage of the final grade the assessment is worth."
              data-position="top left" data-inverted="">
              <i class="question circle icon"></i>
            </span>

            <!-- <span class="tooltip-text top">Percentage of the final grade the assessment is worth.</span> -->
            <!-- </div> -->



          </td>
          <td *ngIf="assessmentFormat.isTimingRequired">At what point during the term
            <!-- <div class="tooltip">
              <i class="question circle icon"></i>
              <span class="tooltip-text top">At what point during the term does the assessment occur?</span>
            </div> -->



            <span class="tooltip-wrapper" data-tooltip="At what point during the term does the assessment occur?" data-position="top left"
              data-inverted="">
              <i class="question circle icon"></i>
            </span>

          </td>
          <td *ngIf="assessmentFormat.isLevelRequired">Level of understanding
            <!-- <div class="tooltip">
              <i class="question circle icon"></i>
              <span class="tooltip-text top">Level of understanding</span>
            </div> -->

            <span class="tooltip-wrapper" data-tooltip="TODO: Level of understanding description" data-position="top left"
              data-inverted="">
              <i class="question circle icon"></i>
            </span>

          </td>
          <td></td>
        </tr>



        <!-- <ng-container *ngIf="assessmentFormat.format == 'list'"> -->
        <tr *ngFor="let assessment of selectedAssessmentMethods">
          <td class="assessment-description-cell">{{assessment.methodName}}
            <span *ngIf="assessment.description">: {{assessment.description}}</span>
          </td>
          <td class="weight-col" *ngIf="assessmentFormat.isWeightRequired">{{assessment.weight}} %</td>
          <td *ngIf="assessmentFormat.isTimingRequired">

            <div *ngIf="assessmentFormat.timingFormat == 'checkbox'">
              <div *ngFor="let timing of assessment.timings">
                <div *ngIf="timing.isSelected">{{timing.description}}
                  <span *ngIf="timing.isOtherTextRequired">: {{timing.otherText}} </span>
                </div>
              </div>
            </div>

            <div *ngIf="assessmentFormat.timingFormat == 'text'">
              <span *ngIf="assessment.timingText">
                {{assessment.timingText}}
              </span>
              <span *ngIf="!assessment.timingText" class="not-specified">Not Specified</span>
            </div>

          </td>
          <td *ngIf="assessmentFormat.isLevelRequired">

            <div *ngIf="assessmentFormat.levelFormat == 'checkbox'">
              <div *ngFor="let level of assessment.levels">
                <div *ngIf="level.isSelected">{{level.description}}
                  <span *ngIf="level.isOtherTextRequired">: {{level.otherText}} </span>
                </div>
              </div>
            </div>

            <div *ngIf="assessmentFormat.levelFormat == 'text'">
              <span *ngIf="assessment.levelText">
                {{assessment.levelText}}
              </span>
              <span *ngIf="!assessment.levelText" class="not-specified">Not Specified</span>
            </div>

          </td>
          <td class="button-col">
            <button class="ui basic button mini" (click)="showEditAssessmentForm(assessment)">
              Edit</button>
            <button class="ui basic button mini delete-button" (click)="deleteAssessment(assessment)">
              Delete</button>
          </td>
        </tr>
        <!-- </ng-container> -->

        <tr *ngIf="assessmentFormat.isWeightRequired && selectedAssessmentMethods.length > 0" class="header-row">
          <td>Total Weight</td>
          <td class="weight-col">
            {{totalWeight}} %
          </td>
          <td colspan="3"></td>
        </tr>

      </table>


      <div class="add-button-area" *ngIf="assessmentFormat.isEnabled">
        <button class="ui primary button tiny action save-button" (click)="showAddAssessmentForm()">
          <i class="icon plus"></i>
          Add Student Assessment Method</button>
      </div>


      <!-- <div class="button-area">

        <div class="nav-button-area">
          <button class="ui right labeled icon button tiny next-step-button" (click)="nextStepClicked()">
            <i class="right arrow icon"></i>Next - Teaching and Learning Activities</button>
        </div>

      </div> -->

    </div>

  </ng-template>


</ng-template>


<!-- Assessment form -->

<div *ngIf="shouldShowForm" class="modal-window" [ngClass]="{'show': shouldShowForm, 'hide': !shouldShowForm}">

  <div class="modal-window-header">
    Student Assessment method</div>

  <div class="modal-window-content ui form">

    <div class="modal-instruction">
      Enter student assessment method information.
    </div>

    <div class="form-area">

      <div class="field required">



        <label>Student Assessment method</label>

        <div class="ui pointing below red basic label" *ngIf="!isAssessmentMethodSelected">
          Please select/define a student assessment method.
        </div>

        <div *ngIf="assessmentFormat.format == 'text'">
          <input type="text" placeholder="Enter assessment method name" [(ngModel)]="selectedAssessmentMethod.methodName" />
        </div>


        <div *ngIf="assessmentFormat.format== 'list'">



          <select class="ui dropdown" name="assessmentMethod" [(ngModel)]="selectedAssessmentMethod.methodId">
            <!--<option *ngFor="" [value]="" [attr.selected]="outcomeMapArray[outcomeMapValue.programOutcomeId] == level.id? true: null">({{level?.abbreviation}}) {{level?.name}}</option>-->
            <option [value]="null">-- Select student assessment method --</option>
            <option *ngFor="let method of assessmentMethodOptions" [value]="method.id">{{method.description}}
              <span *ngIf="method.isOtherTextRequired">(Please describe)</span>
            </option>
          </select>




        </div>



        <!--<textarea rows="2" class="other-text-box" *ngIf="assessmentMethodFormValue.selectedMethod.isTextRequired" [(ngModel)]="assessmentMethodFormValue.selectedMethod.otherText"
                  placeholder="Please specify assessment method"></textarea>-->

      </div>

      <div class="field">
        <label>Description
        </label>
        <div class="label-description">
          Describe the student assessment method (if necessary).
        </div>
        <input type="text" placeholder="e.g. Quiz #1" [(ngModel)]="selectedAssessmentMethod.description">
      </div>

      <div class="field required" *ngIf="assessmentFormat.isWeightRequired">
        <label>Weight (%)
          <!-- <div class="tooltip">
            <i class="question circle icon"></i>
            <span class="tooltip-text top">What percentage of the final grade is the assessment worth? Enter a number
              between 1 and 100.</span>
          </div> -->


          <!-- <span class="tooltip-wrapper" data-tooltip="What percentage of the final grade is the assessment worth? Enter a number
          between 1 and 100."
            data-position="top left" data-inverted="">
            <i class="question circle icon"></i>
          </span> -->
        </label>

        <div class="label-description">
          What percentage of the final grade is the assessment worth? Enter a number
          between 1 and 100.
        </div>


        <div class="four wide field">
          <div class="ui pointing below red basic label" *ngIf="!isWeightNumerical">
            Please enter a number between 1 and 100.
          </div>
          <input type="text" [(ngModel)]="selectedAssessmentMethod.weight" placeholder="0 - 100" (ngModelChange)="verifyNumerical()">

        </div>



      </div>

      <div class="field" *ngIf="assessmentFormat.isTimingRequired">
        <div class="field required">
          <label>
            At what point during the term
            <!-- <div class="tooltip">
              <i class="question circle icon"></i>
              <span class="tooltip-text top">At what point during the term does the assessment occur?.</span>
            </div> -->
          </label>

          <div class="label-description">
            Specify what point during the term does the assessment occur.
          </div>

          <div class="ui pointing below red basic label" *ngIf="!isTimingSelected">
            Please select/define assessment timing.
          </div>


          <div class="checkbox-container" *ngIf="assessmentFormat.timingFormat == 'checkbox'">

            <div *ngFor="let timing of timingOptionsForForm ">
              <div class="ui checkbox">
                <input type="checkbox" class="timing-checkbox" [(ngModel)]="timing.isSelected" [checked]="timing.isSelected">
                <label> {{ timing.description }}
                  <span *ngIf="timing.isOtherTextRequired">(Please specify)</span>
                </label>
              </div>
              <input type="text" class="other-text-box" placeholder="Please specify" *ngIf="timing.isSelected && timing.isOtherTextRequired"
                [(ngModel)]="timing.otherText" />
              <!-- 
                <textarea rows="2" class="other-text-box" placeholder="Please specify" *ngIf="timing.isSelected && timing.isOtherTextRequired"
                  [(ngModel)]="timing.otherText"></textarea> -->
            </div>

          </div>

          <div class="timing-text" *ngIf="assessmentFormat.timingFormat == 'text'">
            <input type="text" [(ngModel)]="selectedAssessmentMethod.timingText" />
          </div>

        </div>

      </div>

      <div class="field" *ngIf="assessmentFormat.isLevelRequired">
        <div class="field required">

          <label>
            Level of understanding
            <!-- <div class="tooltip">
              <i class="question circle icon"></i>
              <span class="tooltip-text top">Level of understanding</span>
            </div> -->

            <!-- <span class="tooltip-wrapper" data-tooltip="TODO: Level of understanding description" data-position="top left"
              data-inverted="">
              <i class="question circle icon"></i>
            </span> -->

          </label>

          <div class="label-description">
            Specify the level of understanding for the assessment item.
          </div>

          <div class="ui pointing below red basic label" *ngIf="!isLevelSelected">
            Please select/define level of understanding.
          </div>


          <div class="checkbox-container" *ngIf="assessmentFormat.levelFormat == 'checkbox'">

            <div *ngFor="let level of levelsForForm">
              <div class="ui checkbox">

                <input type="checkbox" class="level-checkbox" [(ngModel)]="level.isSelected">
                <label> {{ level.description }}
                  <span *ngIf="level.istextRequired">(Please specify)</span>
                </label>



              </div>
              <input type="text" class="other-text-box" placeholder="Please specify" *ngIf="level.isSelected && level.isOtherTextRequired"
                [(ngModel)]="level.otherText" />
            </div>

          </div>

          <div class="level-text" *ngIf="assessmentFormat.levelFormat == 'text'">
            <input type="text" [(ngModel)]="selectedAssessmentMethod.levelText" />
          </div>

        </div>




      </div>


    </div>

  </div>

  <div class="modal-actions">
    <span class="updatingForm" *ngIf="formProcessing">Updating..</span>
    <button class="ui basic button tiny deny" (click)="closeForm()" [disabled]="formProcessing">Cancel</button>
    <button class="ui primary button tiny approve" (click)="submitForm()" [disabled]="formProcessing" [ngClass]="{'loading': formProcessing}">Save</button>
  </div>


</div>


<!-- Delete dialog -->
<app-dialog [dialog]="dialog" [updating]="dialogUpdating" (closeDialog)="closeDialog()" (submitDialog)="proceedDeleteMethod()">
</app-dialog>
<!-- End Delete Dialog -->


<!--<app-in-progress-modal class="in-progress-modal-window" *ngIf="shouldShowInProgressModal" [text]="inProgressModalText" [status]="inProgressStatus" (cancel)="cancelDelete()" (proceed)="proceedDelete()"></app-in-progress-modal>-->

<!-- End Assessment Form -->

<!-- 
<app-user-step-assessment-form *ngIf="shouldShowForm" class="modal-window" [ngClass]="{'show': shouldShowForm, 'hide': !shouldShowForm}"
  [courseId]="courseId" [assessmentFormat]="assessmentFormat" [assessmentMethodOptions]="assessmentMethodOptions" [assessmentMethodFormValue]="assessmentMethodFormValue"
  [action]="action" (submit)="submit()" (update)="update()" (cancel)="closeForm()"></app-user-step-assessment-form> -->
<!-- 
<app-saving-status *ngIf="shouldShowSavingStatus" class="in-progress-modal-window" [title]="savingStatusTitle" [text]="savingStatusText"
  [status]="savingStatus" (cancel)="cancelDelete()" (closeSavingStatus)="closeSavingStatus()" (proceed)="proceedDelete()"></app-saving-status> -->
